export const baseURL = "https://x.coursereel.io/" // "https://backend.aisocials.io/" 
export const appName = "CourseReelAI Max"
export const themeColor = "#AF00FF"